import { PopupBadge } from './related/popup-badge';
import { PopupBody } from './related/popup-body';
import { PopupCloseButton } from './related/popup-close-button';
import { PopupFooter } from './related/popup-footer';
import { PopupHeader } from './related/popup-header';
import { PopupIllustration } from './related/popup-illustration';
import { PopupOverlayRoot } from './related/popup-overlay-root';
import { PopupRoot } from './related/popup-root';
import { PopupSubtitle } from './related/popup-subtitle';
import { PopupTitle } from './related/popup-title';

export const Popup = {
  Root: PopupRoot,
  OverlayRoot: PopupOverlayRoot,
  CloseButton: PopupCloseButton,
  Illustration: PopupIllustration,
  Badge: PopupBadge,
  Header: PopupHeader,
  Title: PopupTitle,
  Subtitle: PopupSubtitle,
  Body: PopupBody,
  Footer: PopupFooter,
};
